<div class="trigger-select">
  <ui-form-field
    class="trigger-select__field"
    type="select"
    [options]="triggerOptions"
    [ngModel]="selectedType"
    [disabled]="locked"
    (ngModelChange)="onSelect($event)"
    [fullWidth]="true"
  ></ui-form-field>
  <span
    *ngIf="locked"
    class="trigger-select__lock"
    [matTooltip]="'workflows.builder.locked_trigger_tooltip' | translate"
    matTooltipPosition="above"
  >
    <ui-svg-icon svgIcon="lock" size="medium"></ui-svg-icon>
  </span>
</div>
